import {LiveChart} from "./live-chart";
import {processPriceUpdate} from "../functions/processPriceUpdate";
// import {getMetalPrices} from "../functions/getMetalPrices";
import {initializeMultiItemCarousels} from "../functions/initializeMultiItemCarousels";

var LiveMetalPrices = function(chartData) {
    var isChartUpdating = false;
    var isTableUpdating = false;
    var xhr;
    var livePricesChart = new LiveChart(chartData);
    var livePricesTable = $('#live-table');
    var liveRatiosTable = $('#live-ratios');
    var summaryTable = $('#summary-table');

    var metalInput = $('#metal-input');
    var weightInput = $('#weight-input');
    var currencyInput = $('#currency-input');
    var periodInput = $('#period-input');

    var chartLoader = $('.chart-loader');
    var summaryLoader = $('.summary-loader');

    this.updateChart = function (manual, updateState) {
        var form = $('#live-metal-prices-form');
        var url = form.attr('action');
        var data = form.serialize();
        data += '&manual=' + manual;

        // cancel existing ajax request
        if (manual == true && xhr && xhr.readyState != 4) {
            xhr.abort();
            isChartUpdating = false;
        }

        // check if request has completed before making a new request
        if (!isChartUpdating) {
            isChartUpdating = true;

            if (manual == true) {
                // show loader
                chartLoader.fadeIn();
                summaryLoader.fadeIn();
            }

            xhr = $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: data,
                success: function (response) {

                    processChartUpdate(response.chart_data, manual);
                    processSummaryUpdate(response.summary, manual);
                    processRatiosUpdate(response.live_ratios, manual);

                    if (updateState == true) {
                        var state = {
                            metal: metalInput.val(),
                            weight: weightInput.val(),
                            currency: currencyInput.val(),
                            period: periodInput.val()
                        };
                    }
                    else {
                        state = null;
                    }

                    processContentUpdate(
                        response.top_selling_products,
                        response.content,
                        response.related_blog_articles,
                        manual, state);

                    // reset var
                    isChartUpdating = false;
                }
            });
        }
    };

    this.updateTable = function (manual, currency) {
        var url = '/data/update-price-table';
        var data = {
            currency: currency
        };

        // cancel existing ajax request
        if (manual == true && xhr && xhr.readyState != 4) {
            xhr.abort();
            isTableUpdating = false;
        }

        // check if request has completed before making a new request
        if (!isTableUpdating) {
            isTableUpdating = true;

            xhr = $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: data,
                success: function(response) {
                    processTableUpdate(response.table_data, manual, currency);
                    processRatiosUpdate(response.live_ratios, manual);

                    // reset var
                    isTableUpdating = false;
                }
            });
        }
    };

    this.processStateChange = function (state) {
        // update visual controls
        $('input[name=metal]').val([state.metal]);
        $('#option-metal').val(state.metal);
        $('#option-weight').val(state.weight);
        $('#option-currency').val(state.currency);
        $('#option-period').val(state.period);

        // update form inputs
        metalInput.val(state.metal);
        weightInput.val(state.weight);
        currencyInput.val(state.currency);
        periodInput.val(state.period);

        this.updateChart(true, false);
    };

    this.setInitialHistoryState = function () {
        var state = {
            metal: metalInput.val(),
            weight: weightInput.val(),
            currency: currencyInput.val(),
            period: periodInput.val()
        };

        window.history.replaceState(state, '', window.location.href);
    };

    function processChartUpdate(chartData, manual) {

        var chart = livePricesChart.myChart;

        chart.series[0].options.name = chartData.title;
        chart.series[0].options.color = chartData.colors.colorRgba;
        chart.series[1].options.color = chartData.colors.colorRgba;
        chart.series[0].options.tooltip.valuePrefix = chartData.symbol;
        chart.series[1].options.tooltip.valuePrefix = chartData.symbol;
        chart.series[0].update(chart.series[0].options);
        chart.series[1].update(chart.series[1].options);
        chart.xAxis[0].update({
            type: 'datetime'
        });
        chart.yAxis[0].update({
            labels: {
                formatter: function () {

                    var digits = livePricesChart.getDigits(this.value);

                    var value = this.value.toFixed(digits);

                    if (chartData.symbol !== '') {
                        return chartData.symbol + value;
                    }
                    else {
                        return value;
                    }

                }
            }
        });
        chart.series[0].setData(chartData.data, true);
        if (typeof chartData.ranges === 'undefined' || (typeof chartData.ranges !== 'undefined' && chartData.ranges.length === 0)) {
            chart.series[1].hide();
        } else {
            chart.series[1].setData(chartData.ranges, true);
            chart.series[1].show();
        }
        if (manual == true) {
            // hide loader
            chart.xAxis[0].setExtremes(
                chart.xAxis[0].dataMin,
                chart.xAxis[0].dataMax
            );
            $( 'input.highcharts-range-selector', $(chart.container).parent() ).datepicker( "option", "minDate", new Date(chart.xAxis[0].dataMin) );
            $( 'input.highcharts-range-selector', $(chart.container).parent() ).datepicker( "option", "maxDate", new Date(chart.xAxis[0].dataMax) );
            chartLoader.fadeOut();
        }
    }

    function processSummaryUpdate(summary, manual) {
        var currentValue = summaryTable.find('.current .text');
        var highValue = summaryTable.find('.high .text');
        var lowValue = summaryTable.find('.low .text');
        var captionMetal = summaryTable.find('caption .caption-metal');
        var changeValue = summaryTable.find('.change .text');
        var currency = currencyInput.val();
        var metal = metalInput.val();
        metal = metal.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });

        if (manual == true) {
            // hide loader
            summaryLoader.fadeOut();
        }

        // update summary table values
        currentValue.text(summary.current);
        highValue.text(summary.high);
        lowValue.text(summary.low);
        captionMetal.text(metal);
        changeValue.text(summary.change)
        changeValue.removeClass('negative positive').addClass(summary.changeType);

        // update summary table currency symbol
        summaryTable.removeClass('gbp usd eur jpy').addClass(currency);
    }

    function processRatiosUpdate(ratios) {
        var goldSilver = liveRatiosTable.find('.gold-silver span');
        var goldPlatinum = liveRatiosTable.find('.gold-platinum span');
        var silverGold = liveRatiosTable.find('.silver-gold span');
        var silverPlatinum = liveRatiosTable.find('.silver-platinum span');
        var platinumGold = liveRatiosTable.find('.platinum-gold span');
        var platinumSilver = liveRatiosTable.find('.platinum-silver span');

        processPriceUpdate(false, goldSilver, ratios.gold_silver);
        processPriceUpdate(false, goldPlatinum, ratios.gold_platinum);
        processPriceUpdate(false, silverGold, ratios.silver_gold);
        processPriceUpdate(false, silverPlatinum, ratios.silver_platinum);
        processPriceUpdate(false, platinumGold, ratios.platinum_gold);
        processPriceUpdate(false, platinumSilver, ratios.platinum_silver);
    }

    function processTableUpdate(tableData, manual, currency) {
        var lastUpdated = $('.live-table .last-updated span');

        var goldRow = livePricesTable.find('.gold');
        var goldOunce = goldRow.find('.ounce span');
        var goldGram = goldRow.find('.gram span');
        var goldKilogram = goldRow.find('.kilogram span');

        var silverRow = livePricesTable.find('.silver');
        var silverOunce = silverRow.find('.ounce span');
        var silverGram = silverRow.find('.gram span');
        var silverKilogram = silverRow.find('.kilogram span');

        var platinumRow = livePricesTable.find('.platinum');
        var platinumOunce = platinumRow.find('.ounce span');
        var platinumGram = platinumRow.find('.gram span');
        var platinumKilogram = platinumRow.find('.kilogram span');

        var palladiumRow = livePricesTable.find('.palladium');
        var palladiumOunce = palladiumRow.find('.ounce span');
        var palladiumGram = palladiumRow.find('.gram span');
        var palladiumKilogram = palladiumRow.find('.kilogram span');

        if (tableData.hasOwnProperty('gold')) {
            processPriceUpdate(manual, goldOunce, tableData.gold.ounce);
            processPriceUpdate(manual, goldGram, tableData.gold.gram);
            processPriceUpdate(manual, goldKilogram, tableData.gold.kilogram);
        }

        if (tableData.hasOwnProperty('silver')) {
            processPriceUpdate(manual, silverOunce, tableData.silver.ounce);
            processPriceUpdate(manual, silverGram, tableData.silver.gram);
            processPriceUpdate(manual, silverKilogram, tableData.silver.kilogram);
        }

        if (tableData.hasOwnProperty('platinum')) {
            processPriceUpdate(manual, platinumOunce, tableData.platinum.ounce);
            processPriceUpdate(manual, platinumGram, tableData.platinum.gram);
            processPriceUpdate(manual, platinumKilogram, tableData.platinum.kilogram);
        }

        if (tableData.hasOwnProperty('palladium')) {
            processPriceUpdate(manual, palladiumOunce, tableData.palladium.ounce);
            processPriceUpdate(manual, palladiumGram, tableData.palladium.gram);
            processPriceUpdate(manual, palladiumKilogram, tableData.palladium.kilogram);
        }

        lastUpdated.text(tableData.updated);

        if (manual == true) {
            // update currency symbol
            livePricesTable.removeClass('gbp usd eur jpy').addClass(currency);
        }
    }

    function processContentUpdate(top_selling_products, content, related_blog_articles, manual, state) {
        if (manual == true) {
            var h1_title = $('.live-chart-row h1');
            var meta_title = $('title');
            var description = $('.tab-content .content:first .main');

            h1_title.text(content.h1_title);
            meta_title.text(content.meta_title);

            if (typeof top_selling_products == 'undefined') {
                top_selling_products = ''
            }
            if (typeof content.description == 'undefined') {
                content.description = ''
            }
            if (typeof related_blog_articles == 'undefined') {
                related_blog_articles = ''
            }

            top_selling_products = '<section>' + top_selling_products + '</section>';
            related_blog_articles = '<section>' + related_blog_articles + '</section>';

            description.html(top_selling_products + content.description + related_blog_articles);

            // getMetalPrices(true, state.currency);

            initializeMultiItemCarousels()

            if (state !== null) {
                window.history.pushState(state, content.meta_title, content.url);
            }
        }
    }
};

global.LiveMetalPrices = LiveMetalPrices;

export {LiveMetalPrices};